import React from 'react';

import { DATA_STATE, DataState, Skeleton } from '../loading';

/**
 * One page of a layout's form, behind the blocks of its sheet (KPR-1860). It
 * fills the sheet, which is the form's own paper or, for an image, the paper the
 * person chose. A sheet's white stands behind it, so a page with transparency
 * still prints on white.
 *
 * Not ready yet, or failed: `DataState`, on the sheet itself, in a place sized
 * as the page will be. `decoding="sync"` because an image still decoding when
 * the print dialog opens is a blank sheet. The print route's button waits on the
 * same answer (hooks/useFormPageImages.js).
 */
export default function PageFormBackdrop({ number, total, name, image, onRetry }) {
	const words = total > 1 ? `page ${number} of this form` : 'this form';
	if (image?.status === 'ready') {
		return (
			<div className="page-sheet__form">
				<img
					className="page-sheet__form-image"
					src={image.url}
					alt={name ? `Page ${number} of ${total} of ${name}` : `Page ${number} of ${total} of the form`}
					decoding="sync"
					draggable={false}
				/>
			</div>
		);
	}
	const failed = image?.status === 'failed' || image?.status === 'missing';
	return (
		<div className="page-sheet__form page-sheet__form--waiting">
			<DataState
				state={failed ? DATA_STATE.ERROR : DATA_STATE.LOADING}
				skeleton={<Skeleton variant="block" height="100%" />}
				error="Nothing on this sheet is ready to print."
				onRetry={onRetry}
				label={words}
			/>
		</div>
	);
}
